import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, formatNumber, formatTime, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import { RentableSpaceDetailsHeader } from './RentableSpaceDetailsHeader'
import Fancybox from '../Fancybox'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'
import { formatDuration } from '../advertisement/bannerAdvertisement/AddAdvertisement.constants'

const RentableSpaceOverview: FC = () => {

    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
        if (categoryId != '4') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const rentablespaceId = (location.state as any)?.rentablespaceId || '';
    const [rentableSpaceDetails, setRentableSpaceDetails] = useState([]);

    const opts = {
        fullScreen: {
            autoStart: true, // Auto-start in full-screen mode
        },
        Thumbs: false,
        // Other options...
    }
    // rentable space Details api call
    const spaceDetailsApiCall = async () => {

        var param: any = {
            rentablespaceId: String(rentablespaceId),
        }
        var response: any = await fetchData("public/rentablespaceDetail", param)

        if (response.status == "200") {
            setRentableSpaceDetails(response.data);
        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        spaceDetailsApiCall()
    }, [])
    return (
        <>
            <PageTitle breadcrumbs={[]}>{t('Rentable Space Overview')}</PageTitle>
            <ToastContainer />
            <RentableSpaceDetailsHeader />
            {rentableSpaceDetails.map((rentableSpace: any, index: any) => {
                const createdDate = new Date(rentableSpace['created'])

                // Add two years
                const createdDateTwoYearsLater = new Date(createdDate)
                createdDateTwoYearsLater.setFullYear(createdDate.getFullYear() + 2)

                // Check if dates are valid
                const isCreatedDateValid = !isNaN(createdDate.getTime())
                const isCreatedDateTwoYearsLaterValid = !isNaN(createdDateTwoYearsLater.getTime())

                // Parse availableDate into an array of objects
                const availableDates: any = rentableSpace['availableDate']
                // Filter and map start dates for 'unavailable' type
                const unavailableDates: any = availableDates
                    .filter((date: any) => date.type === 'unavailable')
                    .map((date: any) =>
                        new Date(date.start).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                        })
                    )
                return (
                    <div className='form' key={index}>
                        {/* <!--begin::Card--> */}
                        <div className='card'>
                            {/* <!--begin::Card header--> */}
                            <div className='card-header'>
                                {/* <!--begin::Card header--> */}
                                <div className='card-title fs-3 fw-bold'>{t('Basic Info')}</div>
                                {/* <!--end::Card header--> */}
                            </div>
                            {/* <!--end::Card header--> */}
                            {/* <!--begin::Card body--> */}
                            <div className='card-body'>
                                {rentableSpace['en_name'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Rentable Space Name (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['en_name']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['ru_name'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Rentable Space Name (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['ru_name']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['uz_name'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Rentable Space Name (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['uz_name']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['standardPeople'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Stabdard People')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['standardPeople']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['maxPeople'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Maximum Capacity')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['maxPeople']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('General Information')}</div>
                                </div>
                                {rentableSpace['en_spaceInformation'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Space Information (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['en_spaceInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['ru_spaceInformation'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Space Information (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['ru_spaceInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['uz_spaceInformation'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Space Information (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['uz_spaceInformation']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['en_generalInformation'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('General Information (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: rentableSpace['en_generalInformation'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['ru_generalInformation'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('General Information (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: rentableSpace['ru_generalInformation'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['uz_generalInformation'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('General Information (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: rentableSpace['uz_generalInformation'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Facility & Services')}</div>
                                </div>
                                {rentableSpace['amenity'] && rentableSpace['amenity'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Facilities & Services')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated amenity names */}
                                                    {rentableSpace['amenity']
                                                        .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                                                        .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}

                                {rentableSpace['isSmokingAllowed'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Is smoking allowed in this studio?')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: rentableSpace['isSmokingAllowed'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['policy'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Policy')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['policy']}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Pricing & Availability')}</div>
                                </div>

                                {rentableSpace['availablespace'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Available Space of the same type')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: rentableSpace['availablespace'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {rentableSpace['extraChildCharge'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Charge for per additional Child')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: rentableSpace['extraChildCharge'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {(rentableSpace['bookByDay'] || rentableSpace[' bookByTime']) && (
                                    <div className='row mb-8'>
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Booking Type')}</div>
                                        </div>
                                        <div className='col-xl-9'>
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {rentableSpace['bookByDay'] === 1 && `✅ ${t('By People')}`}
                                                    {rentableSpace['bookByDay'] === 1 &&
                                                        rentableSpace['bookByTime'] === 1 &&
                                                        ' '}
                                                    {rentableSpace['bookByTime'] === 1 && `✅ ${t('By Hours')}`}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {rentableSpace['bookByDay'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Rentable Space Price (By People)')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {formatNumber(parseFloat(rentableSpace['baseCharge']))}{' '}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['minPeople'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Minimum Number Of People')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {rentableSpace['minPeople']} {t('People')}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['bookByTime'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Rentable Space Price (By Hours)')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Content--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {formatNumber(parseFloat(rentableSpace['baseChargeByHours']))}{' '}
                                                    </div>
                                                </div>
                                                {/* <!--end::Content--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['minHour'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                                    {t('Minimum Hours For Reservation')}
                                                </div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Content--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {formatDuration(rentableSpace['minHour'], 'HOUR', lang)}
                                                    </div>
                                                </div>
                                                {/* <!--end::Content--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                    </>
                                ) : (
                                    ''
                                )}

                                {rentableSpace['fromAvailableHours'] || rentableSpace['toAvailableHours'] ? (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Available Hours')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {rentableSpace['fromAvailableHours'] &&
                                                        rentableSpace['toAvailableHours'] && (
                                                            <div>
                                                                {t('From:')} {formatTime(rentableSpace['fromAvailableHours'])}{' '}
                                                                &nbsp;&nbsp;&nbsp; {/* Add space here */}
                                                                {t('To:')} {formatTime(rentableSpace['toAvailableHours'])}
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                ) : (
                                    ''
                                )}

                                {rentableSpace['availableDate'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Available Date')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div className='d-flex'>
                                                            <div>
                                                                {t('From:')}{' '}
                                                                {isCreatedDateValid
                                                                    ? createdDate.toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'long',
                                                                        year: 'numeric',
                                                                    })
                                                                    : t('Invalid date')}
                                                            </div>
                                                            <div className='date-separator'></div>

                                                            <div>
                                                                {t('To:')}{' '}
                                                                {isCreatedDateTwoYearsLaterValid
                                                                    ? createdDateTwoYearsLater.toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'long',
                                                                        year: 'numeric',
                                                                    })
                                                                    : t('Invalid date')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {rentableSpace['availableDate'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Un Available Date')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div className='d-flex'>
                                                            {unavailableDates.length > 0 && <>{unavailableDates.join(', ')}</>}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Additional options')}</div>
                                </div>
                                {rentableSpace['addtionalSpaceDetail'].map((additionalData: any) => {
                                    return (
                                        <>
                                            {additionalData['en_name'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Option Name (English)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: additionalData['en_name'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {additionalData['ru_name'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Option Name (Russian)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: additionalData['ru_name'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {additionalData['uz_name'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Option Name (Uzbek)')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: additionalData['uz_name'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {additionalData['en_description'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Option Description (English)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: additionalData['en_description'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {additionalData['ru_description'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Option Description (Russian)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: additionalData['ru_description'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {additionalData['uz_description'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>
                                                                {t('Option Description (Uzbek)')}
                                                            </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: additionalData['uz_description'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}

                                            {additionalData['spacePrice'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Option Price')}</div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    {formatNumber(parseFloat(additionalData['spacePrice']))}{' '}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            {additionalData['maxUseCapacity'] ? (
                                                <>
                                                    {/* <!--begin::Row--> */}
                                                    <div className='row mb-8'>
                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-3'>
                                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Max Use Capacity')} </div>
                                                        </div>
                                                        {/* <!--end::Col--> */}

                                                        {/* <!--begin::Col--> */}
                                                        <div className='col-xl-9'>
                                                            {/* <!--begin::Progress--> */}
                                                            <div className='d-flex flex-column'>
                                                                <div className=' fw-semibold text-gray-600 mt-3'>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: additionalData['maxUseCapacity'],
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Progress--> */}
                                                        </div>
                                                        {/* <!--end::Col--> */}
                                                    </div>
                                                    {/* <!--end::Row--> */}
                                                </>
                                            ) : (
                                                ''
                                            )}

                                            {additionalData['additionalImage'] ? (
                                                <div className='col-xl-12'>
                                                    {/* <!--begin::Engage widget 7--> */}
                                                    <div className='card card-flush h-xl-100'>
                                                        <div className='pt-7'>
                                                            <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                                                <Fancybox options={opts}>
                                                                    {/* <!--begin::Col--> */}
                                                                    <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                                        {/* <!--begin::Overlay--> */}
                                                                        <a
                                                                            data-fancybox='gallery'
                                                                            className='d-block overlay'
                                                                            data-fslightbox='lightbox-hot-sales'
                                                                            href={additionalData['additionalImage']}
                                                                        >
                                                                            <div
                                                                                className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                                                style={{
                                                                                    height: '266px',
                                                                                    backgroundImage: `url('${additionalData['additionalImage']}')`,
                                                                                }}
                                                                            ></div>
                                                                            {/* <!--end::Image--> */}

                                                                            {/* <!--begin::Action--> */}
                                                                            <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                                                <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                                            </div>
                                                                            {/* <!--end::Action-->       */}
                                                                        </a>
                                                                        {/* <!--end::Overlay-->          */}
                                                                    </div>
                                                                    {/* <!--end::Col-->      */}
                                                                </Fancybox>
                                                            </div>
                                                            {/* <!--end::Row--> */}
                                                        </div>
                                                        {/* <!--end::Card body--> */}
                                                    </div>
                                                    {/* <!--end::Engage widget 7--> */}
                                                </div>
                                            ) : (
                                                <div className='col-xl-12'>
                                                    {/* <!--begin::Engage widget 1--> */}
                                                    <div className='card h-md-100' dir='ltr'>
                                                        {/* <!--begin::Body--> */}
                                                        <div className='card-body d-flex flex-column flex-center'>
                                                            {/* <!--begin::Heading--> */}
                                                            <div className='mb-2'>
                                                                {/* <!--begin::Illustration--> */}
                                                                <div className='py-10 text-center'>
                                                                    <img
                                                                        src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                                                                        className='theme-light-show h-125px'
                                                                        alt=''
                                                                    />
                                                                    <img
                                                                        src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                                                                        className='theme-dark-show h-125px'
                                                                        alt=''
                                                                    />
                                                                </div>
                                                                {/* <!--end::Illustration--> */}
                                                            </div>
                                                            {/* <!--end::Heading--> */}
                                                        </div>
                                                        {/* <!--end::Body--> */}
                                                    </div>
                                                    {/* <!--end::Engage widget 1--> */}
                                                </div>
                                            )}
                                        </>
                                    )
                                })}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Rentable Space photos')}</div>
                                </div>

                                {rentableSpace['images'].length != 0 ? (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 7--> */}
                                        <div className='card card-flush h-xl-100'>
                                            <div className='pt-7'>
                                                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                                    {rentableSpace['images'].map((images: any, index: any) => {
                                                        return (
                                                            <>
                                                                <Fancybox options={opts}>
                                                                    {/* <!--begin::Col--> */}
                                                                    <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                                        {/* <!--begin::Overlay--> */}
                                                                        <a
                                                                            data-fancybox='gallery'
                                                                            className='d-block overlay'
                                                                            data-fslightbox='lightbox-hot-sales'
                                                                            href={images['mediaPath']}
                                                                        >
                                                                            <div
                                                                                className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                                                style={{
                                                                                    height: '266px',
                                                                                    backgroundImage: `url('${images['mediaPath']}')`,
                                                                                }}
                                                                            ></div>
                                                                            {/* <!--end::Image--> */}

                                                                            {/* <!--begin::Action--> */}
                                                                            <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                                                <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                                            </div>
                                                                            {/* <!--end::Action-->       */}
                                                                        </a>
                                                                        {/* <!--end::Overlay-->          */}
                                                                    </div>
                                                                    {/* <!--end::Col-->      */}
                                                                </Fancybox>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Row--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 7--> */}
                                    </div>
                                ) : (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 1--> */}
                                        <div className='card h-md-100' dir='ltr'>
                                            {/* <!--begin::Body--> */}
                                            <div className='card-body d-flex flex-column flex-center'>
                                                {/* <!--begin::Heading--> */}
                                                <div className='mb-2'>
                                                    {/* <!--begin::Illustration--> */}
                                                    <div className='py-10 text-center'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                                                            className='theme-light-show h-125px'
                                                            alt=''
                                                        />
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                                                            className='theme-dark-show h-125px'
                                                            alt=''
                                                        />
                                                    </div>
                                                    {/* <!--end::Illustration--> */}
                                                </div>
                                                {/* <!--end::Heading--> */}
                                            </div>
                                            {/* <!--end::Body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 1--> */}
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* <!--end::Card--> */}
                    </div>
                )
            })}
        </>
    )
}

export { RentableSpaceOverview }